import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LunchDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lunch_dining"}/>
}
